import React from "react";
import PropTypes from "prop-types";
import "./MemberCard.css";
import Card from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import avatar from "../../Male_Avatar.jpg";
import { CardActions } from "@mui/material";
import { Stack } from "@mui/joy";

const MemberCard = ({ member }) => {
  const goToWebsite = () => {
    window.open(member?.officialWebsiteUrl, "_blank");
  };
  return (
    <Card
      className="member-card"
      alt={member.fullName}
      variant="plain"
      sx={(theme) => ({
        display: "flex",
        alignItems: 'stretch',
        justifyContent: 'space-between',
        flexDirection: "column",
        flexGrow: 1,
        boxShadow: theme.shadow.md,
        cursor: "pointer",
        background: (theme) =>
          `linear-gradient(180deg, ${
            member.party === "Democratic"
              ? theme.vars.palette.primary[500]
              : member.party === "Republican"
              ? theme.vars.palette.danger[500]
              : theme.vars.palette.warning[200]
          } 0%, ${
            member.party === "Democratic"
              ? theme.vars.palette.primary[500]
              : member.party === "Republican"
              ? theme.vars.palette.danger[500]
              : theme.vars.palette.warning[200]
          } 32.99%, #FFF 33%, #FFF 100%)`,
      })}
    >
      <Stack direction={'column'} sx={{alignItems: 'center'}}>
        <img src={member.imageUrl || avatar} alt={member.fullName} />
        <Stack direction={'column'} sx={{alignItems: 'center'}}>
          <Typography level="title-lg">{member.fullName}</Typography>
          <Typography level="title-sm" color="primary">
            {member.party} - {member.state}
          </Typography>
        </Stack>
      </Stack>
      <CardActions>
        <Button
          variant="outlined"
          color="primary"
          sx={{ width: "100%" }}
          onClick={() => goToWebsite()}
        >
          Visit {member.firstName}'s website
        </Button>
      </CardActions>
    </Card>
  );
};

// Prop types for our Component
MemberCard.propTypes = {
  member: PropTypes.object.isRequired,
};

// Default Props for our Component
MemberCard.defaultProps = {};

export default MemberCard;
